const commonButtonsRules = () => {
  return {
    color: 'var(--white)',
    hoverColor: 'var(--white)',
    activeColor: 'var(--white)',

    borderColor: 'transparent',
    hoverBorderColor: 'transparent',
    activeBorderColor: 'transparent'
  }
}
export const buttonsConfig = () => {
  return {
    root: {
      // paddingX: '9px',
      // paddingY: '7px',
      borderRadius: '{borderRadius.md}',
      primary: {
        // color: 'var(--primary-surface-color)',
        // hoverColor: 'var(--primary-surface-color)',
        // activeColor: 'var(--primary-surface-color)',

        hoverBackground: '{primary.400}',
        activeBackground: '{primary.400}',

        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        activeBorderColor: 'transparent'
      },

      secondary: {
        background: 'var(--secondary-300)',

        hoverBackground: 'var(--secondary-500)',
        activeBackground: 'var(--secondary-500)'
      },

      text: {
        primary: {
          color: 'var(--site-text)',
          hoverBackground: 'transparent',
          activeBackground: 'transparent'
        }
      },

      outlined: {
        primary: {
          color: 'var(--site-text)',
          borderColor: 'var(--primary-300)'
        }
      },

      success: {
        ...commonButtonsRules(),
        background: '{green.500}',
        hoverBackground: '{green.400}',
        activeBackground: '{green.600}'
      },

      info: {
        ...commonButtonsRules(),
        background: '{sky.500}',
        hoverBackground: '{sky.400}',
        activeBackground: '{sky.600}'
      },
      danger: {
        ...commonButtonsRules(),
        background: '{red.500}',
        hoverBackground: '{red.400}',
        activeBackground: '{red.600}'
      },
      warn: commonButtonsRules(),
      help: commonButtonsRules()
    }
  }
}
